'use strict';

import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersSelectors, ordersOperations } from '@/state/domains/orders';
import { locationListSelectors, locationListOperations } from '@/state/domains/locationList';

import s from './styles.scss';

const sx = cn.bind(s);

let timeoutId;

export default connect(
	(state, props) => ({
		user: usersSelectors.getPageUser(state, props),
		username: usersSelectors.getUsername(state, props),
		date: appSelectors.getPageDate(state, props),
		modals: appSelectors.getModalStates(state, props),
		btns: locationListSelectors.getActionBtns(state, props),
		selected: locationListSelectors.getSelected(state, props),
		allAreSelected: locationListSelectors.allAreSelected(state, props),
		locationList: locationListSelectors.getList(state, props),
	}),
	{
		postOptimizeRoute: locationListOperations.postOptimizeRoute,
		postAssignNextDay: locationListOperations.postAssignNextDay,
		postReverseSelection: locationListOperations.postReverseSelection,
		postReorderedLocations: locationListOperations.postReorderedLocations,
		moveSelection: locationListOperations.moveSelection,
		setModalOpen: appOperations.setModalOpen,
		selectAll: locationListOperations.selectAll,
		unselectAll: locationListOperations.unselectAll,
		//setSelected: appOperations.setSelected,
	}
)(
	({
		user,
		username,
		date,
		modals,
		btns,
		selected,
		allAreSelected,
		locationList,
		numLocationItems,
		postOptimizeRoute,
		postAssignNextDay,
		postReverseSelection,
		postReorderedLocations,
		moveSelection: _moveSelection,
		setModalOpen,
		selectAll,
		unselectAll,
		expanded,
		setExpanded,
	}) => {

		const reformList = listItems => listItems.map(i => ({
			locationId: i.locationId,
			priority: i.priority,
			flag: i.flag,
			jobs: i.jobs,
		}));

		const [ barrier, setBarrier ] = useState(true);

		useEffect(
			() => {
				if (!barrier) {

					const locations = reformList(locationList);

					postReorderedLocations(
						username,
						date,
						locations
					);

					setBarrier(true);
				}
			},
			[ locationList, barrier ]
		);

		const moveSelection = direction => {

			_moveSelection(direction);

			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(
				() =>  {
					setBarrier(false);
				},
				1000
			);
		};

		const reverseSelection = () => {

			const selectedIndices = locationList.reduce(
				(indices, listItem, i) => listItem.isChecked ?
					[ ...indices, i ] : indices,
				[]
			);
			postReverseSelection(username, date, selectedIndices);
		};

		const handleCheck = useCallback(
			() => {
				if (allAreSelected) {
					unselectAll();
				} else {
					selectAll();
				}
			},
			[
				allAreSelected,
			]
		);

		const optimizeRoute = () => {

			const selectedIndices = locationList.reduce(
				(indices, listItem, i) => listItem.isChecked ?
					[ ...indices, i ] : indices,
				[]
			);
			postOptimizeRoute(username, date, selectedIndices);
		};

		const assignNextDay = () => {

			const selectedIndices = locationList.reduce(
				(indices, listItem, i) => listItem.isChecked ?
					[ ...indices, i ] : indices,
				[]
			);
			postAssignNextDay(username, date, selectedIndices);
		};

		return (
			<div className={ s.actionBtns }>
				<div className={ s.checkAll }>
					<input
						type='checkbox'
						checked={ allAreSelected }
						onChange={ handleCheck }
					/>
				</div>
				<button
					title='Expand Rows'
					disabled={ false }
					onClick={ () => setExpanded(!expanded) }
				>
					<FontAwesomeIcon icon='expand' color='#777'/>
				</button>
				<button
					className={ sx({ disabled: !btns.deleteJobs }) }
					title='Delete'
					onClick={ () => setModalOpen('deleteJobs') }
					disabled={ !btns.deleteJobs }
				>
					<FontAwesomeIcon icon='trash-alt' color='#777'/>
				</button>
				<button
					className={ sx({ disabled: !btns.moveUp }) }
					title='Move up'
					onClick={ () => moveSelection(-1) }
					disabled={ !btns.moveUp }
				>
					<FontAwesomeIcon icon='long-arrow-alt-up' color='#777'/>
				</button>
				<button
					className={ sx({ disabled: !btns.moveDown }) }
					title='Move down'
					onClick={ () => moveSelection(1) }
					disabled={ !btns.moveDown }
				>
					<FontAwesomeIcon icon='long-arrow-alt-down' color='#777'/>
				</button>
				<button
					className={ sx({ disabled: !btns.reverse }) }
					title='Reverse'
					onClick={ reverseSelection }
					disabled={ !btns.reverse }
				>
					<FontAwesomeIcon icon='exchange-alt' color='#777'/>
				</button>
				<button
					style={{ display: 'none' }}
					className={ sx({ disabled: !btns.copyNextDay }) }
					title='Assign for next day'
					disabled={ !btns.copyNextDay }
					onClick={ assignNextDay }
				>
					<FontAwesomeIcon icon='angle-double-right' color='#777'/>
				</button>
				<button
					title='Add to Route'
					disabled={ false }
					onClick={
						() => setModalOpen('addToRoute', { locationList, date })
					}
				>
					<FontAwesomeIcon icon='plus' color='#777'/>
				</button>
				<button
					className={ sx({ disabled: !btns.optimize }) }
					title='Optimize'
					disabled={ false }
					onClick={ optimizeRoute }
				>
					<FontAwesomeIcon icon='chart-line' color='#777'/>
				</button>
			</div>
		);
	}
);
